import { gql } from "@apollo/client";

export const DELETE_CHAT = gql`
    mutation DeleteChat($id: ID!) {
        deleteChat(id: $id) {
            id
        }
    }
`;